var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#5648B6",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8733_9577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0707 20.2099L28.3805 10.7751C28.2099 10.6842 28.0195 10.6367 27.8262 10.6367C27.6329 10.6367 27.4426 10.6842 27.2719 10.7751L9.58172 20.2099C9.39303 20.3104 9.23523 20.4604 9.12519 20.6437C9.01516 20.8271 8.95703 21.0368 8.95703 21.2507C8.95703 21.4645 9.01516 21.6743 9.12519 21.8576C9.23523 22.0409 9.39303 22.1909 9.58172 22.2914L13.6741 24.4747V31.6127C13.6728 32.192 13.886 32.7512 14.2726 33.1827C16.2038 35.3335 20.5305 38.9409 27.8262 38.9409C30.2453 38.9609 32.6463 38.5227 34.9023 37.6495V42.4789C34.9023 42.7917 35.0266 43.0917 35.2477 43.3128C35.4689 43.534 35.7689 43.6583 36.0817 43.6583C36.3944 43.6583 36.6944 43.534 36.9156 43.3128C37.1368 43.0917 37.261 42.7917 37.261 42.4789V36.5099C38.7989 35.6222 40.1886 34.4996 41.3799 33.1827C41.7664 32.7512 41.9796 32.192 41.9784 31.6127V24.4747L46.0707 22.2914C46.2594 22.1909 46.4172 22.0409 46.5273 21.8576C46.6373 21.6743 46.6954 21.4645 46.6954 21.2507C46.6954 21.0368 46.6373 20.8271 46.5273 20.6437C46.4172 20.4604 46.2594 20.3104 46.0707 20.2099ZM27.8262 36.5822C21.4474 36.5822 17.6956 33.4657 16.0328 31.6127V25.7322L27.2719 31.7262C27.4426 31.8171 27.6329 31.8646 27.8262 31.8646C28.0195 31.8646 28.2099 31.8171 28.3805 31.7262L34.9023 28.2486V35.08C33.0448 35.9468 30.7038 36.5822 27.8262 36.5822ZM39.6197 31.6068C38.9128 32.3913 38.1218 33.0957 37.261 33.7075V26.9897L39.6197 25.7322V31.6068ZM36.6713 24.6324L36.6389 24.6133L28.3835 20.2099C28.108 20.0692 27.7884 20.0423 27.4933 20.1351C27.1983 20.2279 26.9515 20.4328 26.8061 20.7058C26.6607 20.9788 26.6284 21.2979 26.7161 21.5945C26.8037 21.8911 27.0044 22.1414 27.2749 22.2914L34.1652 25.968L27.8262 29.3484L12.6421 21.2507L27.8262 13.153L43.0103 21.2507L36.6713 24.6324Z",
    fill: "#5648B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8733_9577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.7391,
    height: 35.4286,
    fill: "white",
    transform: "translate(8.95703 10.0801)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.ddf6e7406f7423d4dd5d09c1f18c9db2.svg";
export { ForwardRef as ReactComponent };